import {
	StyledHorizontalContainer,
	StyledVerticalContainer,
} from '../Container';
import { Selector } from '../Selector';

export interface ISelectorBlockProps {
	title: string;
	drawableId: number;
	maxDrawableId: number;
	textureId: number;
	minTextureId?: number;
	maxTextureId: number;
	onDrawableChange?: (drawableId: number) => void;
	onTextureChange?: (textureId: number) => void;
}

const SelectorBlock: React.FC<ISelectorBlockProps> = ({
	title,
	drawableId,
	maxDrawableId,
	textureId,
	minTextureId,
	maxTextureId,
	onDrawableChange,
	onTextureChange,
}) => {
	return (
		<StyledVerticalContainer>
			<span>{title}</span>
			<StyledHorizontalContainer>
				<Selector
					title={'Drawable'}
					index={drawableId}
					maxIndex={maxDrawableId}
					onChange={onDrawableChange}
				/>
				<Selector
					title={'Texture'}
					index={textureId}
					minIndex={minTextureId ?? 0}
					maxIndex={maxTextureId}
					onChange={onTextureChange}
				/>
			</StyledHorizontalContainer>
		</StyledVerticalContainer>
	);
};

export { SelectorBlock };
